import { field, asString } from '../utils/enriched-data';

/**
 * Returns the placeholder image URL for an item type.
 * Maps item types to their placeholder images in /images/placeholders/.
 */
export default function placeholderUrl(item: unknown): string {
  const type = asString(field(item, 'type'));
  const validTypes = [
    'movie',
    'tv_show',
    'book',
    'music',
    'podcast',
    'recipe',
    'video_game',
    'place',
    'product',
    'person',
  ];
  const safeType = validTypes.includes(type) ? type : 'unknown';
  return `/images/placeholders/${safeType}.png`;
}
